var _g, _g2, _path, _path2, _path3, _g3, _g4, _g5, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlgorPay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_19368_25487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 50C16 49.4477 16.4477 49 17 49H59C59.5523 49 60 49.4477 60 50V50.644C60 51.1981 59.8114 51.7357 59.4653 52.1684C58.5391 53.3261 57.137 54 55.6544 54H20.3456C18.863 54 17.4609 53.3261 16.5347 52.1684C16.1886 51.7357 16 51.1981 16 50.644V50Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 50C16.5 49.7239 16.7239 49.5 17 49.5H59C59.2761 49.5 59.5 49.7239 59.5 50V50.644C59.5 51.0846 59.3501 51.512 59.0749 51.856C58.2436 52.8951 56.9851 53.5 55.6544 53.5H20.3456C19.0149 53.5 17.7564 52.8951 16.9251 51.856L16.5347 52.1684L16.9251 51.856C16.6499 51.512 16.5 51.0846 16.5 50.644V50Z",
    stroke: "url(#paint0_radial_19368_25487)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_19368_25487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 26C20 23.7909 21.7909 22 24 22H52C54.2091 22 56 23.7909 56 26V46C56 47.1046 55.1046 48 54 48H22C20.8954 48 20 47.1046 20 46V26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 26C20.5 24.067 22.067 22.5 24 22.5H52C53.933 22.5 55.5 24.067 55.5 26V46C55.5 46.8284 54.8284 47.5 54 47.5H22C21.1716 47.5 20.5 46.8284 20.5 46V26Z",
    stroke: "url(#paint1_radial_19368_25487)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 26C20.5 24.067 22.067 22.5 24 22.5H52C53.933 22.5 55.5 24.067 55.5 26V46C55.5 46.8284 54.8284 47.5 54 47.5H22C21.1716 47.5 20.5 46.8284 20.5 46V26Z",
    stroke: "url(#paint2_radial_19368_25487)",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 26C20.5 24.067 22.067 22.5 24 22.5H52C53.933 22.5 55.5 24.067 55.5 26V46C55.5 46.8284 54.8284 47.5 54 47.5H22C21.1716 47.5 20.5 46.8284 20.5 46V26Z",
    stroke: "url(#paint3_radial_19368_25487)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5227 32.0143H18.3893C18.3987 31.906 18.4035 31.7965 18.4035 31.6857C18.4035 29.5667 16.6433 27.8714 14.5 27.8714C12.3567 27.8714 10.5965 29.5667 10.5965 31.6857C10.5965 31.7965 10.6013 31.906 10.6107 32.0143H1.47729C0.68184 32.0143 0.254044 31.1757 0.656716 30.5728L2.21546 28.239C2.85356 27.2836 3.19402 26.167 3.19402 25.0249V16.7714C3.19402 11.1111 7.90994 6.5 13.7555 6.5H15.2445C21.0901 6.5 25.806 11.1111 25.806 16.7714V25.0249C25.806 26.167 26.1464 27.2836 26.7845 28.239L28.3433 30.5728C28.746 31.1757 28.3182 32.0143 27.5227 32.0143ZM14.5 34.5C13.3858 34.5 12.4278 33.8952 11.9403 33.0143H17.0597C16.5722 33.8952 15.6142 34.5 14.5 34.5ZM17.4035 31.6857C17.4035 31.7968 17.3968 31.9064 17.3839 32.0143H11.6161C11.6032 31.9064 11.5965 31.7968 11.5965 31.6857C11.5965 30.1439 12.8838 28.8714 14.5 28.8714C16.1162 28.8714 17.4035 30.1439 17.4035 31.6857Z",
    fill: "#FF0508"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5227 32.0143H18.3893C18.3987 31.906 18.4035 31.7965 18.4035 31.6857C18.4035 29.5667 16.6433 27.8714 14.5 27.8714C12.3567 27.8714 10.5965 29.5667 10.5965 31.6857C10.5965 31.7965 10.6013 31.906 10.6107 32.0143H1.47729C0.68184 32.0143 0.254044 31.1757 0.656716 30.5728L2.21546 28.239C2.85356 27.2836 3.19402 26.167 3.19402 25.0249V16.7714C3.19402 11.1111 7.90994 6.5 13.7555 6.5H15.2445C21.0901 6.5 25.806 11.1111 25.806 16.7714V25.0249C25.806 26.167 26.1464 27.2836 26.7845 28.239L28.3433 30.5728C28.746 31.1757 28.3182 32.0143 27.5227 32.0143ZM14.5 34.5C13.3858 34.5 12.4278 33.8952 11.9403 33.0143H17.0597C16.5722 33.8952 15.6142 34.5 14.5 34.5ZM17.4035 31.6857C17.4035 31.7968 17.3968 31.9064 17.3839 32.0143H11.6161C11.6032 31.9064 11.5965 31.7968 11.5965 31.6857C11.5965 30.1439 12.8838 28.8714 14.5 28.8714C16.1162 28.8714 17.4035 30.1439 17.4035 31.6857Z",
    fill: "url(#paint4_linear_19368_25487)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5227 32.0143H18.3893C18.3987 31.906 18.4035 31.7965 18.4035 31.6857C18.4035 29.5667 16.6433 27.8714 14.5 27.8714C12.3567 27.8714 10.5965 29.5667 10.5965 31.6857C10.5965 31.7965 10.6013 31.906 10.6107 32.0143H1.47729C0.68184 32.0143 0.254044 31.1757 0.656716 30.5728L2.21546 28.239C2.85356 27.2836 3.19402 26.167 3.19402 25.0249V16.7714C3.19402 11.1111 7.90994 6.5 13.7555 6.5H15.2445C21.0901 6.5 25.806 11.1111 25.806 16.7714V25.0249C25.806 26.167 26.1464 27.2836 26.7845 28.239L28.3433 30.5728C28.746 31.1757 28.3182 32.0143 27.5227 32.0143ZM14.5 34.5C13.3858 34.5 12.4278 33.8952 11.9403 33.0143H17.0597C16.5722 33.8952 15.6142 34.5 14.5 34.5ZM17.4035 31.6857C17.4035 31.7968 17.3968 31.9064 17.3839 32.0143H11.6161C11.6032 31.9064 11.5965 31.7968 11.5965 31.6857C11.5965 30.1439 12.8838 28.8714 14.5 28.8714C16.1162 28.8714 17.4035 30.1439 17.4035 31.6857Z",
    stroke: "url(#paint5_radial_19368_25487)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_19368_25487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 50C16 49.4477 16.4477 49 17 49H59C59.5523 49 60 49.4477 60 50V50.644C60 51.1981 59.8114 51.7357 59.4653 52.1684C58.5391 53.3261 57.137 54 55.6544 54H20.3456C18.863 54 17.4609 53.3261 16.5347 52.1684C16.1886 51.7357 16 51.1981 16 50.644V50Z",
    fill: "url(#paint6_linear_19368_25487)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 50C16 49.4477 16.4477 49 17 49H59C59.5523 49 60 49.4477 60 50V50.644C60 51.1981 59.8114 51.7357 59.4653 52.1684C58.5391 53.3261 57.137 54 55.6544 54H20.3456C18.863 54 17.4609 53.3261 16.5347 52.1684C16.1886 51.7357 16 51.1981 16 50.644V50Z",
    fill: "url(#paint7_radial_19368_25487)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 50C16.5 49.7239 16.7239 49.5 17 49.5H59C59.2761 49.5 59.5 49.7239 59.5 50V50.644C59.5 51.0846 59.3501 51.512 59.0749 51.856C58.2436 52.8951 56.9851 53.5 55.6544 53.5H20.3456C19.0149 53.5 17.7564 52.8951 16.9251 51.856L16.5347 52.1684L16.9251 51.856C16.6499 51.512 16.5 51.0846 16.5 50.644V50Z",
    stroke: "url(#paint8_radial_19368_25487)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_19368_25487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 26C20 23.7909 21.7909 22 24 22H52C54.2091 22 56 23.7909 56 26V46C56 47.1046 55.1046 48 54 48H22C20.8954 48 20 47.1046 20 46V26Z",
    fill: "url(#paint9_linear_19368_25487)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 26C20 23.7909 21.7909 22 24 22H52C54.2091 22 56 23.7909 56 26V46C56 47.1046 55.1046 48 54 48H22C20.8954 48 20 47.1046 20 46V26Z",
    fill: "url(#paint10_radial_19368_25487)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 26C20.5 24.067 22.067 22.5 24 22.5H52C53.933 22.5 55.5 24.067 55.5 26V46C55.5 46.8284 54.8284 47.5 54 47.5H22C21.1716 47.5 20.5 46.8284 20.5 46V26Z",
    stroke: "url(#paint11_radial_19368_25487)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 26C20.5 24.067 22.067 22.5 24 22.5H52C53.933 22.5 55.5 24.067 55.5 26V46C55.5 46.8284 54.8284 47.5 54 47.5H22C21.1716 47.5 20.5 46.8284 20.5 46V26Z",
    stroke: "url(#paint12_radial_19368_25487)",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 26C20.5 24.067 22.067 22.5 24 22.5H52C53.933 22.5 55.5 24.067 55.5 26V46C55.5 46.8284 54.8284 47.5 54 47.5H22C21.1716 47.5 20.5 46.8284 20.5 46V26Z",
    stroke: "url(#paint13_radial_19368_25487)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_b_19368_25487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 50C16 49.4477 16.4477 49 17 49H59C59.5523 49 60 49.4477 60 50V50.644C60 51.1981 59.8114 51.7357 59.4653 52.1684C58.5391 53.3261 57.137 54 55.6544 54H20.3456C18.863 54 17.4609 53.3261 16.5347 52.1684C16.1886 51.7357 16 51.1981 16 50.644V50Z",
    fill: "url(#paint14_linear_19368_25487)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 50C16 49.4477 16.4477 49 17 49H59C59.5523 49 60 49.4477 60 50V50.644C60 51.1981 59.8114 51.7357 59.4653 52.1684C58.5391 53.3261 57.137 54 55.6544 54H20.3456C18.863 54 17.4609 53.3261 16.5347 52.1684C16.1886 51.7357 16 51.1981 16 50.644V50Z",
    fill: "url(#paint15_radial_19368_25487)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 50C16.5 49.7239 16.7239 49.5 17 49.5H59C59.2761 49.5 59.5 49.7239 59.5 50V50.644C59.5 51.0846 59.3501 51.512 59.0749 51.856C58.2436 52.8951 56.9851 53.5 55.6544 53.5H20.3456C19.0149 53.5 17.7564 52.8951 16.9251 51.856L16.5347 52.1684L16.9251 51.856C16.6499 51.512 16.5 51.0846 16.5 50.644V50Z",
    stroke: "url(#paint16_radial_19368_25487)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36 32C36 31.4477 36.4477 31 37 31H40C40.5523 31 41 31.4477 41 32V44C41 44.5523 40.5523 45 40 45H37C36.4477 45 36 44.5523 36 44V32Z",
    fill: "#88A2B1",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43 34C43 33.4477 43.4477 33 44 33H47C47.5523 33 48 33.4477 48 34V44C48 44.5523 47.5523 45 47 45H44C43.4477 45 43 44.5523 43 44V34Z",
    fill: "#88A2B1",
    fillOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29 38C29 37.4477 29.4477 37 30 37H33C33.5523 37 34 37.4477 34 38V44C34 44.5523 33.5523 45 33 45H30C29.4477 45 29 44.5523 29 44V38Z",
    fill: "#88A2B1",
    fillOpacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28 38C28 36.8954 28.8954 36 30 36H31C32.1046 36 33 36.8954 33 38V43C33 43.5523 32.5523 44 32 44H29C28.4477 44 28 43.5523 28 43V38Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35 32C35 30.8954 35.8954 30 37 30H38C39.1046 30 40 30.8954 40 32V43C40 43.5523 39.5523 44 39 44H36C35.4477 44 35 43.5523 35 43V32Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42 34C42 32.8954 42.8954 32 44 32H45C46.1046 32 47 32.8954 47 34V43C47 43.5523 46.5523 44 46 44H43C42.4477 44 42 43.5523 42 43V34Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_19368_25487",
    x: 8,
    y: 41,
    width: 60,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_19368_25487"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_19368_25487",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_19368_25487",
    x: 12,
    y: 14,
    width: 52,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_19368_25487"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_19368_25487",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_19368_25487",
    x: 8,
    y: 41,
    width: 60,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_19368_25487"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_19368_25487",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_19368_25487",
    x: 12,
    y: 14,
    width: 52,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_19368_25487"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_19368_25487",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_b_19368_25487",
    x: 8,
    y: 41,
    width: 60,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_19368_25487"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_19368_25487",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_19368_25487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.5 49) rotate(90) scale(3.75 17.8593)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_19368_25487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.5 38.9722) rotate(4.42478) scale(14.0419 10.1967)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_19368_25487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.5 26.6944) rotate(144.162) scale(5.5509 23.2933)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_19368_25487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.5 27.0556) rotate(124.695) scale(13.1762 15.4161)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_19368_25487",
    x1: 0,
    y1: 6,
    x2: 14.5,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_19368_25487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-7.80769 -7.94231) rotate(55.5392) scale(34.4959)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_19368_25487",
    x1: 16,
    y1: 49,
    x2: 16.354,
    y2: 55.2299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09C9C",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D7F0",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_19368_25487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16 49) scale(44 5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_19368_25487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.5 49) rotate(90) scale(3.75 17.8593)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_19368_25487",
    x1: 20,
    y1: 22,
    x2: 30.3823,
    y2: 50.7509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09C9C",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D7F0",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_19368_25487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20 22) scale(36 26)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_19368_25487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.5 38.9722) rotate(4.42478) scale(14.0419 10.1967)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_19368_25487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.5 26.6944) rotate(144.162) scale(5.5509 23.2933)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_19368_25487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.5 27.0556) rotate(124.695) scale(13.1762 15.4161)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_19368_25487",
    x1: 16,
    y1: 49,
    x2: 16.354,
    y2: 55.2299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09C9C",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D7F0",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_19368_25487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16 49) scale(44 5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_19368_25487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.5 49) rotate(90) scale(3.75 17.8593)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlgorPay);
export default __webpack_public_path__ + "static/media/AlgorPay.48512124c0904906b71d67aa240b0c5b.svg";
export { ForwardRef as ReactComponent };